import { lazy, Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useUiI18n } from "../../I18n/index.ts";
import { useClientDispatch, useClientSelector } from "../../Redux/clientHooks.ts";
import { friendsOpenSelector, setFriendsOpen } from "../../Redux/social.slice.ts";

const FriendsPanel = lazy(() =>
	import("./FriendsPanel.tsx").then((module) => ({ default: module.FriendsPanel })),
);

export function FriendsDialog() {
	const { t } = useUiI18n();
	const dispatch = useClientDispatch();
	const open = useClientSelector(friendsOpenSelector);
	const { pathname } = useLocation();
	useEffect(() => {
		dispatch(setFriendsOpen(false));
	}, [dispatch, pathname]);
	const close = () => dispatch(setFriendsOpen(false));
	return (
		<Dialog
			open={open}
			onClose={close}
			fullWidth
			maxWidth="md"
			aria-labelledby="world-friends-title"
		>
			<DialogTitle id="world-friends-title">{t("social.title")}</DialogTitle>
			<DialogContent sx={{ p: { xs: 0, sm: 1 } }}>
				<Suspense fallback={<Alert severity="info">{t("world.loading")}</Alert>}>
					{open && <FriendsPanel />}
				</Suspense>
			</DialogContent>
			<DialogActions>
				<Button onClick={close}>{t("world.close")}</Button>
			</DialogActions>
		</Dialog>
	);
}
